import pino from 'pino';

import { getLogAttributes, sendToOtel } from './loggerUtils';

const pinoLogger = pino({
  messageKey: 'message',
  errorKey: 'message',
  level: process.env.LOG_LEVEL ?? 'info',
  timestamp: pino.stdTimeFunctions.isoTime,
  formatters: {
    level: (label) => {
      return { level: label.toUpperCase() };
    },
    log: (object) => {
      return { ...object, ...getLogAttributes() };
    },
  },
  browser: {
    formatters: {
      level: (label) => {
        return { level: label.toUpperCase() };
      },
      log: (object) => {
        return { ...object, ...getLogAttributes() };
      },
    },
    transmit: typeof window !== 'undefined' ? { send: sendToOtel } : undefined,
  },
});

let genericLogger = pinoLogger;

if (typeof window !== 'undefined') genericLogger = pinoLogger.child({ url: window.location.href });

export { genericLogger };
